"use client";

import Image, { type ImageProps } from "next/image";
import { useImageSrc } from "./MediaOverrideContext";
import { imageFocalPoints } from "@/data/image-focal-points";

/**
 * Drop-in replacement for next/image that applies admin image overrides by path.
 * Renders identically to <Image> until an override is set in the Media Map.
 */
export default function SiteImage(props: ImageProps) {
  const original = typeof props.src === "string" ? props.src : "";
  const resolved = useImageSrc(original);
  const src = typeof props.src === "string" ? resolved : props.src;
  const objectPosition = typeof src === 'string' && !props.className?.includes('object-contain')
    ? imageFocalPoints[src] : undefined;
  return <Image {...props} src={src} style={{ objectPosition, ...props.style }} />;
}
